const {
    BroadcastChannel
} = require('broadcast-channel');

export default {
    data: function () {
        return {
            name: null,
            messages: {},
            created: {},
            channels: {},
        }
    },
    created: function () {},
    methods: {
        startBroadcast(name) {
            console.log("START BROADCAST: " + name);
            this.channels[name] = new BroadcastChannel(name);
            this.channels[name].onmessage = msg => this.receiveMessage(msg, name);
            console.log(this.channels);
        },
        createChannel(name, r, h, w, q) {
            console.log("CREATING CHANNEL: " + name);
            this.startBroadcast(name);

            let routeData = this.$router.resolve({
                name: r,
                query: (q ? q : {})
            });
            window.open(routeData.href, '_blank', 'location=no,height=' + h + ',width=' + w + ',scrollbars=yes,status=yes,toolbar=no,titlebar=no');

            this.created[name] = true;
            this.$forceUpdate();
        },
        receiveMessage(m, n) {
            console.log("RECEIVING: " + m[0].dockey);
            this.messages[n] = m;
            this.$forceUpdate();
        },
        sendMessage(n, m) {
            console.log("SENDING: " + m[0].dockey + " ON: " + n);
            this.channels[n].postMessage(m);
        },
        endBroadcast(name) {
            console.log("END BROADCAST: " + name);
            this.channels[name].close();
        }
    }
};